import type { JettonBetInfo, JettonStatus } from '@/entities/jetton';
import type { CurrencyCode } from '@/shared/lib/currency';
import type { ButtonProps } from '@/shared/ui/Button';

export interface BtnConfig {
  label: string;
  variant?: ButtonProps['variant'];
  outline?: boolean;
  disabled: boolean;
  action: 'bet' | 'cancel' | 'cashout' | 'none';
}

interface Params {
  status: JettonStatus;
  alreadyBet: boolean;
  alreadyCashedOut: boolean;
  isBetValid: boolean;
  myBet: JettonBetInfo | null | undefined;
  myCashout: { multiplier: number; payout: number } | null | undefined;
  betAmount: number;
  selectedCurrency: CurrencyCode;
}

export function getBtnConfig({
  status,
  alreadyBet,
  alreadyCashedOut,
  isBetValid,
  myBet,
  myCashout,
  betAmount,
  selectedCurrency,
}: Params): BtnConfig {
  if (status === 'crashed') {
    if (myCashout) {
      return {
        label: `+${myCashout.payout.toFixed(selectedCurrency === 'STARS' ? 0 : 2)} ${selectedCurrency} cashed out`,
        variant: 'success',
        disabled: true,
        action: 'none',
      };
    }
    if (alreadyBet && !alreadyCashedOut) {
      return { label: '✗ Lost this round', variant: 'error', disabled: true, action: 'none' };
    }
    return { label: 'Next round soon…', disabled: true, action: 'none' };
  }

  if (status === 'flying') {
    if (!alreadyBet) return { label: 'Round in progress', disabled: true, action: 'none' };
    if (alreadyCashedOut)
      return {
        label: `✓ Cashed out at ${myBet!.cashoutMultiplier!.toFixed(2)}x`,
        variant: 'success',
        disabled: true,
        action: 'none',
      };
    return { label: '', disabled: false, action: 'cashout' };
  }

  if (alreadyBet) {
    return { label: 'Cancel Bet', variant: 'error', outline: true, disabled: false, action: 'cancel' };
  }

  return {
    label: `Place Bet — ${betAmount.toFixed(selectedCurrency === 'STARS' ? 0 : 2)} ${selectedCurrency}`,
    disabled: !isBetValid,
    action: isBetValid ? 'bet' : 'none',
  };
}
